/**
 * Утилиты для работы со статусами заказов
 */

export interface StatusInfo {
  iconName: string;
  title: string;
  bgColor: string;
  textColor: string;
}

/**
 * Получение информации о статусе заказа
 */
export const getOrderStatusInfo = (status: string): StatusInfo => {
  switch (status) {
    case 'new':
      return {
        iconName: 'file-tray-full',
        title: 'Новый заказ',
        bgColor: 'white',
        textColor: '#065f46'
      };
    case 'watching':
      return {
        iconName: 'eye',
        title: 'Просмотрен',
        bgColor: 'white',
        textColor: '#1e40af'
      };
    case 'calculating':
      return {
        iconName: 'calculator',
        title: 'В просчете',
        bgColor: 'white',
        textColor: '#d97706'
      };
    case 'price_given':
      return {
        iconName: 'pricetag',
        title: 'Цена объявлена',
        bgColor: 'white',
        textColor: '#7c3aed'
      };
    case 'pending_confirmation':
      return {
        iconName: 'time',
        title: 'Ожидает подтверждения',
        bgColor: 'white',
        textColor: '#d97706'
      };
    case 'executing':
      return {
        iconName: 'construct',
        title: 'В работе',
        bgColor: 'white',
        textColor: '#7c3aed'
      };
    case 'rejected':
      return {
        iconName: 'close-circle',
        title: 'Отказ',
        bgColor: 'white',
        textColor: '#dc2626'
      };
    case 'defect':
      return {
        iconName: 'warning',
        title: 'Брак',
        bgColor: 'white',
        textColor: '#dc2626'
      };
    case 'completed':
      return {
        iconName: 'checkmark-circle',
        title: 'Завершен',
        bgColor: 'white',
        textColor: '#065f46'
      };
    case 'archived':
      return {
        iconName: 'archive',
        title: 'Архивирован',
        bgColor: 'white',
        textColor: '#6b7280'
      };
    default:
      return {
        iconName: 'help-circle',
        title: 'Неизвестный статус',
        bgColor: 'white',
        textColor: '#6b7280'
      };
  }
};

/**
 * Получение текста статуса заказа
 */
export const getStatusText = (status: string): string => {
  const statusTexts: Record<string, string> = {
    'new': 'Новый',
    'watching': 'Просмотр',
    'calculating': 'На просчете',
    'price_given': 'Цена объявлена',
    'pending_confirmation': 'Ожидает подтверждения',
    'executing': 'В работе',
    'rejected': 'Отказ',
    'defect': 'Брак',
    'completed': 'Завершен',
    'archived': 'Архив'
  };
  return statusTexts[status] || status;
};

/**
 * Получение иконки статуса для отображения в заголовке чата
 */
export const getStatusIcon = (status: string): string => {
  const statusInfo = getOrderStatusInfo(status);
  return statusInfo.iconName;
};
